<template>
    <div>
        <div class="d-flex justify-content-end my-2">
            <b-button
                    v-b-modal.createMaterial
                    size="sm"
                    variant="success"
                    v-if="$can('create', 'materials')"
            >
                Добавить материал в справочник
            </b-button>
        </div>
        <b-row class="my-2 align-items-center">
            <b-col cols="12" md="6" class="mb-2 mb-md-0">
                <b-input-group size="sm">
                    <b-form-input
                            v-model="filter"
                            type="search"
                            id="filterInput"
                            placeholder="Введите для поиска"
                    ></b-form-input>
                </b-input-group>
            </b-col>
            <b-col cols="12" md="6">
                <div class="d-flex flex-wrap justify-content-md-end align-items-center">
                    <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            align="fill"
                            size="sm"
                            class="my-0 mb-2 mb-md-0 mr-2"
                    ></b-pagination>
                    <div class="mb-2 mb-md-0">
                        <b-form-group
                                label="На странице"
                                label-cols="6"
                                label-size="sm"
                                label-for="perPageSelect"
                                class="mb-0 d-flex align-items-center"
                        >
                            <b-form-select
                                    v-model="perPage"
                                    id="perPageSelect"
                                    size="sm"
                                    :options="pageOptions"
                            ></b-form-select>
                        </b-form-group>
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-table
                responsive="sm"
                :fields="fields"
                :filter="filter"
                small
                striped
                :items="items"
                :current-page="currentPage"
                :per-page="perPage"
                @filtered="onFiltered"
                :tbody-tr-class="rowClass"
                sticky-header="80vh"
        >
            <template v-slot:cell(status)="data">
                <b-badge v-if="data.item.is_active === false" variant="secondary">Отключён</b-badge>
                <span v-else class="text-muted">—</span>
            </template>
            <template v-slot:cell(actions)="data">
                <i class="fas fa-pen text-center text-success mx-2"
                   @click="onEdit(data.item)"
                   v-if="$can('update', 'materials')"
                ></i>
                <i class="fas fa-trash-alt text-danger text-center mx-2"
                   @click="onDelete(data.item)"
                   v-if="$can('delete', 'materials')"
                ></i>
                <b-button
                        v-if="$can('update', 'materials')"
                        size="sm"
                        :variant="data.item.is_active === false ? 'outline-success' : 'outline-secondary'"
                        :title="data.item.is_active === false
                            ? 'Вернуть материал в договоры и новые отчёты'
                            : 'Скрыть материал из договоров и новых отчётов, сохранив историю'"
                        v-b-tooltip.hover
                        @click="changeStatus(data.item)"
                >
                    {{ data.item.is_active === false ? 'Сделать действующим' : 'Отключить' }}
                </b-button>
            </template>
        </b-table>
        <create-material></create-material>
        <delete-material></delete-material>
        <edit-material></edit-material>
    </div>
</template>

<script>
    import CreateMaterial from "./CreateMaterial/CreateMaterial.vue";
    import DeleteMaterial from "./DeleteMaterial/DeleteMaterial.vue";
    import EditMaterial from "./EditMaterial/EditMaterial.vue";

    export default {
        components: {
            CreateMaterial,
            DeleteMaterial,
            EditMaterial
        },
        computed: {
            items() {
                return this.$store.state.materials.directory;
            }
        },
        data() {
            return {
                fields: [
                    {
                        key: `name`,
                        label: `Имя материала`,
                        sortable: true
                    },
                    {
                        key: `measures`,
                        label: `Единицы измрения`,
                        sortable: true
                    },
                    {
                        key: `parent_group_name`,
                        label: `Имя родительской группы`,
                        sortable: true
                    },
                    {
                        key: `status`,
                        label: `Состояние`
                    },
                    {
                        label: ``,
                        key: `actions`,
                        class: `material-directory-actions`
                    }
                ],
                filter: null,
                filterOn: [],
                perPage: 200,
                pageOptions: [5, 10, 15, 20, 100, 200],
                totalRows: 1,
                currentPage: 1,
                value: null
            }
        },
        async mounted() {
            await this.$store.dispatch(`getDirectory`);
            this.totalRows = this.items.length;
        },
        methods: {
            onDelete({id}) {
                this.$store.commit(`setSelectedMaterialId`, id);
                this.$bvModal.show(`deleteMaterial`);
            },
            onEdit({id}) {
                this.$store.commit(`setSelectedMaterialId`, id);
                this.$bvModal.show(`editMaterial`);
            },
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
            async changeStatus(item) {
                try {
                    await this.$store.dispatch('setMaterialStatus', {
                        id: item.id,
                        isActive: item.is_active === false
                    });
                    await this.$store.dispatch('getDirectory');
                } catch (error) {
                    this.$store.dispatch('showErrorModal',
                        error && error.response && error.response.data || 'Не удалось изменить состояние материала');
                }
            },
            rowClass(item) {
                return item && item.is_active === false ? 'material-directory-row--disabled' : '';
            }
        },
        name: "MaterialDirectory"
    }
</script>

<style scoped>
::v-deep .material-directory-row--disabled {
    opacity: .58;
}

::v-deep .material-directory-actions {
    min-width: 255px;
    white-space: nowrap;
}
</style>
